import { Link, NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Key,
  ShieldCheck,
  Activity,
  ScrollText,
  Download,
  BookOpen,
  Beaker,
  LogOut,
} from 'lucide-react'
import { ROUTES, APP } from '@/lib/constants'
import { setAccessToken } from '@/lib/api'

const NAV = [
  { to: ROUTES.DASHBOARD, label: 'Dashboard', icon: LayoutDashboard },
  { to: ROUTES.USAGE, label: 'Uso & quotas', icon: Activity },
  { to: ROUTES.API_KEYS, label: 'API keys', icon: Key },
  { to: ROUTES.CERT, label: 'Certificado', icon: ShieldCheck },
  { to: ROUTES.AUDIT_HISTORY, label: 'Audit / Habeas Data', icon: ScrollText },
  { to: ROUTES.DATA_EXPORT, label: 'Export de datos', icon: Download },
  { to: ROUTES.INTEGRATION_GUIDE, label: 'Guía de integración', icon: BookOpen },
  { to: ROUTES.SANDBOX, label: 'Sandbox', icon: Beaker },
] as const

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-bg-base text-fg-primary">
      <aside className="hidden w-60 flex-none border-r border-border bg-bg-surface lg:block">
        <div className="flex h-16 items-center gap-2 border-b border-border px-5">
          <Link to={ROUTES.DASHBOARD} className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-500 font-mono text-xs font-bold text-white">
              Tx
            </div>
            <span className="text-sm font-semibold text-fg-primary">{APP.name}</span>
          </Link>
        </div>
        <nav className="px-3 py-4">
          {NAV.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === ROUTES.DASHBOARD}
                className={({ isActive }) =>
                  `mb-1 flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-fg-secondary hover:bg-bg-elevated hover:text-fg-primary'
                  }`
                }
              >
                <Icon className="h-4 w-4 flex-none" />
                {item.label}
              </NavLink>
            )
          })}
          <button
            type="button"
            onClick={() => {
              setAccessToken(null)
              window.location.href = ROUTES.LOGIN
            }}
            className="mt-4 flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium text-fg-secondary hover:bg-bg-elevated hover:text-fg-primary"
          >
            <LogOut className="h-4 w-4 flex-none" />
            Salir
          </button>
        </nav>
      </aside>
      <main className="flex-1 overflow-y-auto p-6 lg:p-10">{children}</main>
    </div>
  )
}
